export enum UserTypeCode {
  PLEB = 'Pleb',
  MERCHANT = 'Merchant'
}

export class UserType {
  private constructor(private readonly _code: UserTypeCode) {}

  get code(): string {
    return this._code;
  }

  static pleb = new UserType(UserTypeCode.PLEB);
  static merchant = new UserType(UserTypeCode.MERCHANT);

  static values: UserType[] = [
    UserType.pleb,
    UserType.merchant
  ];
}
